import React, { memo } from 'react';
import { flowRight } from 'lodash';
import { MappingReference, useCellReferences } from 'components/ScalarSpreadsheet/hooks';
import FastValueViewer from 'components/ScalarSpreadsheet/utilities/FastValueViewer';
import withDialog from 'components/WithDialog';
import { useActiveCell } from 'context/ActiveCellContext/ActiveCellContext';
import { useDocumentFootnotes } from 'context/DocumentFootnotesContext';
import ReferencesValueViewerProps from './ReferencesValueViewer.props';

const ReferencesValueViewer = (props: ReferencesValueViewerProps) => {
  const { cell } = props;
  const { mappingReferences } = cell as { mappingReferences?: MappingReference[] };
  const { documentSourceMap } = useDocumentFootnotes();
  const { setActiveCell } = useActiveCell();

  const referenceText = useCellReferences(mappingReferences, documentSourceMap);
  const cellId = cell.key ? String(cell.key) : `${cell.row ?? 'r'}-${cell.col ?? 'c'}`;

  const handleSelect = (e: React.MouseEvent | React.KeyboardEvent) => {
    e.stopPropagation();
    setActiveCell({
      id: cellId,
      content: referenceText
    });
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleSelect(e);
    }
  };

  return (
    <div
      onClick={handleSelect}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      <FastValueViewer {...props} />
    </div>
  );
};

// Memoize to prevent re-renders when other cells are clicked
const MemoizedViewer = memo(ReferencesValueViewer);

const enhancements = flowRight(withDialog);
export default enhancements(MemoizedViewer);
